import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateWhatsAppChannels = ({
  height = 128,
  width = 128,
  ...props
}: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 128 128"
    data-test="whats-app-empty-state"
    {...props}
  >
    <g clipPath="url(#clip0_11487_192203)">
      <path
        d="M115.84 72.3085C115.839 64.6681 114.129 57.1247 110.833 50.2314C107.538 43.3382 102.742 37.2697 96.7965 32.4711C90.851 27.6725 83.9069 24.2654 76.4734 22.4995C69.0398 20.7337 61.3053 20.6539 53.837 22.266C46.3686 23.878 39.3556 27.1412 33.3124 31.8161C27.2691 36.491 22.3488 42.4591 18.912 49.2829C15.4753 56.1068 13.6093 63.6132 13.4509 71.252C13.2926 78.8907 14.8458 86.4681 17.9967 93.4285H111.283C114.293 86.7946 115.847 79.5931 115.84 72.3085Z"
        fill="#F5F4F4"
      />
      <path
        d="M14.0801 93.4277H113.92"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.32007 93.4277H11.5201"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.48 93.4277H119.68"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.9105 105.459C95.9105 106.739 81.8305 107.891 64.3329 107.891C46.8353 107.891 32.7681 106.803 32.7681 105.459C32.7681 104.115 46.8481 103.027 64.3329 103.027C81.8177 103.027 95.9105 104.179 95.9105 105.459Z"
        fill="#F5F4F4"
      />
      <circle cx="47" cy="81.5" r="23.5" fill="white" stroke="#6A266D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.6667 70.1406C31.6667 69.5883 32.1145 69.1406 32.6667 69.1406H61.3334C61.8857 69.1406 62.3334 69.5883 62.3334 70.1406V92.4606C62.3334 93.0129 61.8857 93.4606 61.3334 93.4606H32.6667C32.1145 93.4606 31.6667 93.0129 31.6667 92.4606V70.1406Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.6667 76.541C39.6667 75.9887 40.1145 75.541 40.6667 75.541H53.3334C53.8857 75.541 54.3334 75.9887 54.3334 76.541V83.501C54.3334 84.0533 53.8857 84.501 53.3334 84.501H40.6667C40.1145 84.501 39.6667 84.0533 39.6667 83.501V76.541Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.6667 77.4609L45.6667 80.4049C46.4918 80.8622 47.5083 80.8622 48.3334 80.4049L54.3334 77.4609"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.1841 98.5809C44.289 97.0771 44.9195 95.2996 45.0001 93.4609"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.9998 98.5007L49 93.4609L50.9998 98.5007Z"
        fill="#B56DC6"
      />
      <path d="M50.9998 98.5007L49 93.4609H45L43 98.5007H50.9998Z" fill="#B56DC6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.9998 98.5007L49 93.4609L50.9998 98.5007Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.9998 98.5007L49 93.4609H45L43 98.5007H50.9998Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M41 98.5801H53" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9998 90.5H61.9998H31.9998Z"
        fill="#B56DC6"
      />
      <path d="M31.9998 90.5H61.9998V92.5H31.9998V90.5Z" fill="#B56DC6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.9998 90.5H61.9998H31.9998Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9998 90.5H61.9998V92.5H31.9998V90.5Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M32.5 92.5H61.5" stroke="#B56DC6" />
      <circle cx="93" cy="81.5" r="15.5" fill="white" stroke="#6A266D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.5 84V91C94.5 92.1046 93.6046 93 92.5 93H85.5C84.3954 93 83.5 92.1046 83.5 91V76C83.5 74.8954 84.3954 74 85.5 74H89.5"
        fill="#6A266D"
      />
      <path
        d="M94.5 84V91C94.5 92.1046 93.6046 93 92.5 93H85.5C84.3954 93 83.5 92.1046 83.5 91V76C83.5 74.8954 84.3954 74 85.5 74H89.5H94.5V84Z"
        fill="#6A266D"
      />
      <path
        d="M94.5 84V91C94.5 92.1046 93.6046 93 92.5 93H85.5C84.3954 93 83.5 92.1046 83.5 91V76C83.5 74.8954 84.3954 74 85.5 74H89.5H94.5V84Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.5 78H83.5V89H94.5V78H89.5Z"
        fill="#E6FBFF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M94.5 89H83.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M87.5 76H89.5" stroke="#B56DC6" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.5 77.5C106.5 78.3284 105.828 79 105 79H99.5L96.5 82V79H93C92.1716 79 91.5 78.3284 91.5 77.5V71.5C91.5 70.6716 92.1716 70 93 70H105C105.828 70 106.5 70.6716 106.5 71.5V77.5Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.25 74C99.1119 74 99 74.1119 99 74.25C99 74.3881 99.1119 74.5 99.25 74.5C99.3881 74.5 99.5 74.3881 99.5 74.25C99.5 74.1119 99.3881 74 99.25 74"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.75 74C102.612 74 102.5 74.1119 102.5 74.25C102.5 74.3881 102.612 74.5 102.75 74.5C102.888 74.5 103 74.3881 103 74.25C103 74.1119 102.888 74 102.75 74"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M95.75 74C95.6119 74 95.5 74.1119 95.5 74.25C95.5 74.3881 95.6119 74.5 95.75 74.5C95.8881 74.5 96 74.3881 96 74.25C96 74.1119 95.8881 74 95.75 74"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89 90.75V90.75C89.1381 90.75 89.25 90.8619 89.25 91V91C89.25 91.1381 89.1381 91.25 89 91.25V91.25C88.8619 91.25 88.75 91.1381 88.75 91V91C88.75 90.8619 88.8619 90.75 89 90.75"
        stroke="#B56DC6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="70" cy="43.5" r="15.5" fill="white" stroke="#6A266D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.5 34C63.5 32.8954 64.3954 32 65.5 32H74.5C75.6046 32 76.5 32.8954 76.5 34V53C76.5 54.1046 75.6046 55 74.5 55H65.5C64.3954 55 63.5 54.1046 63.5 53V34Z"
        fill="#6A266D"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M76.5 51H63.5H76.5Z" fill="#E6FBFF" />
      <path d="M76.5 51H63.5V36H76.5V51Z" fill="#E6FBFF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.5 51H63.5H76.5Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M76.5 51H63.5V36H76.5V51Z"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M65.5 41C65.5 40.4477 65.9477 40 66.5 40H73.5C74.0523 40 74.5 40.4477 74.5 41V45C74.5 45.5523 74.0523 46 73.5 46H66.5C65.9477 46 65.5 45.5523 65.5 45V41Z"
        fill="#FDF5FF"
        stroke="#6A266D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M65.5 42H74.5H65.5Z" fill="#B56DC6" />
      <path d="M65.5 42H74.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M70.5 44H72.5H70.5Z" fill="#B56DC6" />
      <path d="M70.5 44H72.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70 52.75C70.1381 52.75 70.25 52.8619 70.25 53C70.25 53.1381 70.1381 53.25 70 53.25C69.8619 53.25 69.75 53.1381 69.75 53C69.75 52.8619 69.8619 52.75 70 52.75Z"
        fill="#B56DC6"
      />
      <path
        d="M70 52.75C70.1381 52.75 70.25 52.8619 70.25 53V53C70.25 53.1381 70.1381 53.25 70 53.25V53.25C69.8619 53.25 69.75 53.1381 69.75 53V53C69.75 52.8619 69.8619 52.75 70 52.75"
        stroke="#B56DC6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M76.5 36H63.5H76.5Z" fill="#B56DC6" />
      <path d="M76.5 36H63.5" stroke="#6A266D" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M68.5 34H71.5" stroke="#B56DC6" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_11487_192203">
        <rect width="128" height="128" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
